import React, { useContext } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuContext } from "../context/context";
import BarsMenu from "./BarsMenu";
import { useState } from "react";
import { useEffect } from "react";

const HeaderUI = styled.header`
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  top: 0;
  background: ${(props) => (props.background ? "var(--black)" : "transparent")};
  transition: all 0.4s ease;
  padding: 15px 0px;
  z-index: 1000;

  a:first-child {
    height: 100%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 868px) {
    justify-content: space-between;
    background: ${(props) =>
      props.background ? "var(--black)" : "transparent"};
  }
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 868px) {
    position: fixed;
    top: 90px;
    background-color: var(--black);
    height: calc(100vh - 90px);
    width: 100%;
    transform: ${(props) =>
      props.isOpen ? "translateX(0)" : "translateX(200%)"};
  }
  transition: all 0.4s ease;
`;

const NavList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;
  @media (max-width: 868px) {
    flex-direction: column;
    width: 100%;
    gap: 50px;
  }
`;

const NavItem = styled.li`
  font-size: 1rem;
  font-family: var(--roboto);
  position: relative;
  a {
    color: var(--white);
  }
  a::after {
    content: "";
    height: 2px;
    width: 100%;
    background: var(--red);
    position: absolute;
    bottom: -4px;
    left: 0;
    transform: scaleX(0);
    transform-origin: bottom right;
    transition: transform 0.15s ease;
  }
  a:hover::after {
    transform-origin: bottom left;
    transform: scaleX(1);
  }

  @media (max-width: 868px) {
    font-size: 1.3rem;
    font-weight: 300;
  }
`;

const Logo = styled.img`
  height: 80%;
  cursor: pointer;
  @media (max-width: 868px) {
    margin-left: 50px;
  }
  @media (max-width: 576px) {
    margin-left: 30px;
  }
`;

const Header = ({ landing }) => {
  const ctx = useContext(MenuContext);
  const [color, setColor] = useState(false);
  const changeBackground = () => {
    setColor(window.scrollY >= 90);
  };

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
  }, []);

  return (
    <>
      <HeaderUI background={ctx.isMenuOpen || color || !landing}>
        {!landing ? (
          <Link to="/" onClick={() => document.documentElement.scrollTo(0, 0)}>
            <Logo src="/images/logo.png" alt="logo" />
          </Link>
        ) : (
          <Logo src="/images/logo.png" alt="logo" />
        )}
        <Nav isOpen={ctx.isMenuOpen}>
          <NavList>
            <NavItem>
              <Link to="/" onClick={window.innerWidth < 768 && ctx.toggleMenu}>
                Home
              </Link>
            </NavItem>
            <NavItem>
              <Link
                to="/sobre-nosotros"
                onClick={window.innerWidth < 768 && ctx.toggleMenu}
              >
                Sobre nosotros
              </Link>
            </NavItem>
            <NavItem>
              <Link
                to="/flota"
                onClick={window.innerWidth < 768 && ctx.toggleMenu}
              >
                Flota
              </Link>
            </NavItem>
            <NavItem>
              <Link
                to="/como-contratarnos"
                onClick={window.innerWidth < 768 && ctx.toggleMenu}
              >
                Como contratarnos
              </Link>
            </NavItem>
            <NavItem>
              <Link
                to="/contacto"
                onClick={window.innerWidth < 768 && ctx.toggleMenu}
              >
                Contacto
              </Link>
            </NavItem>
          </NavList>
        </Nav>

        <BarsMenu color={`var(--white)`} />
      </HeaderUI>
    </>
  );
};

export default Header;
